import { displayToast } from '../../../helpers/notification';
import { StoreSettingTypes as Type } from '../../types/store';

export function getStoreDetailsRequest(id: any) {
  return {
    type: Type.STORE_DETAIL_REQUEST,
    id,
  };
}

export function getStoreDetailsRequestSuccess(data: any) {
  return {
    type: Type.STORE_DETAIL_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getStoreDetailsRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.STORE_DETAIL_REQUEST_FAILURE,
    error: error,
  };
}
